module.exports = __webpack_public_path__ + "img/content-preparation.d89a8795.jpg";